import { requestSuccess } from "@Api";
import { UPDATE_COMPANY } from "@Actions/types";

const companyUpdated = (data) => {
	return (dispatch) => {
		dispatch(requestSuccess(UPDATE_COMPANY, data));
	};
};

export default companyUpdated;
